import qs from 'qs'
import PassportUtil from '@byted-growth/byted-passport-util'
import Cookies from 'js-cookie'
import { form, index as apis } from '~/const/apis'
import { APP_ID } from '~/const/userRegister'
import axios from '~/utils/axios'

const postPassport = (url: string, data: any, config = {}) => {
  return axios.post(url, qs.stringify({
    language: Cookies.get('lang_type') || 'en',
    aid: APP_ID,
    mix_mode: 1,
    ...PassportUtil.encryptParams({
      account_sdk_source: 'web',
      type: 26,
      ...data
    }, ['type', 'mobile', 'code'])
  }), {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'x-tt-passport-csrf-token': Cookies.get('passport_csrf_token') || Cookies.get('passport_csrf_token_default') || ''
    }
  })
}

export const actions = {

  phoneSendCode: (_: any, { phone }: any) => new Promise((resolve, reject) => {
    postPassport(apis.send_code, { mobile: phone, scene: 1 })
      .then((res) => {
        resolve(res.data)
      }).catch((res) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(res?.data)
    })
  }),

  phoneVerifyCode: (_: any, { phone, code }: any) => new Promise((resolve, reject) => {
    postPassport(apis.verify_code, { mobile: phone, code })
      .then((res) => {
        resolve(res.data)
      }).catch((res) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(res?.data)
    })
  }),

  phoneBind: (_: any, { phone, code }: any) => new Promise((resolve, reject) => {
    postPassport(apis.bind_phone, { mobile: phone, type: 17, code })
      .then((res) => {
        resolve(res.data)
      }).catch((res) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(res?.data)
    })
  }),

  assessRiskInfo: (_: any, { eventName, userRiskInfo }: any) => axios.post(
    form.phone_shark,
    { 'event_name': eventName, 'risk_info': userRiskInfo },
    { params: { 'req_src': 'getstarted' } }
  )
}
